module.exports = __webpack_public_path__ + "media/images/ui__themeToggleLight--dark-d651c5803008ec530414a5ec6870fc5f.png";